import React from "react";
export default function ReadyForYourFitting() {
  return <section id="contact" className="w-full bg-gradient-to-br from-[#0a2540] via-[#0a2540] to-[#028090] px-6 py-24 md:px-16">
      <div className="mx-auto max-w-6xl text-center">
        <h2 className="mb-6 font-serif text-4xl leading-tight text-white md:text-6xl">
          Ready to remove the friction from care?
        </h2>

        <p className="mx-auto mb-14 max-w-3xl text-lg leading-8 text-white/75">
          Whether you&apos;re a patient who keeps putting off appointments, or a
          provider looking to fill your schedule and improve outcomes —
          KolayHealth makes access easier.
        </p>

        <div className="grid gap-6 md:grid-cols-2">
          <div className="rounded-3xl border border-white/10 bg-white/10 p-8 text-left backdrop-blur-sm">
            <div className="mb-3 text-xs font-bold uppercase tracking-[0.12em] text-white/50">
              For Patients
            </div>
            <h3 className="mb-4 font-serif text-2xl text-white">
              Start getting care easily.
            </h3>
            <p className="mb-6 text-sm leading-7 text-white/75">
              Join the waitlist and be among the first to experience
              frictionless healthcare access.
            </p>
            <button className="rounded-full bg-white px-6 py-3 text-sm font-semibold text-[#028090]">
              Join the Waitlist
            </button>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/10 p-8 text-left backdrop-blur-sm">
            <div className="mb-3 text-xs font-bold uppercase tracking-[0.12em] text-white/50">
              For Healthcare Providers
            </div>
            <h3 className="mb-4 font-serif text-2xl text-white">
              Fill your schedule. Improve your metrics.
            </h3>
            <p className="mb-6 text-sm leading-7 text-white/75">
              See how KolayHealth works with your practice and helps turn open
              availability into completed care.
            </p>
            <button className="rounded-full bg-white px-6 py-3 text-sm font-semibold text-[#028090]">
              Request a Demo
            </button>
          </div>
        </div>

        <p className="mt-10 font-serif text-lg italic text-white/40">
          KolayHealth — May it be easy for you.
        </p>
      </div>
    </section>;
}